import { UserAuthActionType } from '../context/actions';
import { useUserAuthContext } from '../context/context';
import { AuthStep, TwoFactorMethod, UserIntent } from '../context/reducer';

interface UseAuthStepResponse {
  authStep: AuthStep;
  userIntent: UserIntent;
  twoFactorMethods: TwoFactorMethod[];
  onLoginIntentSuccess: ({ email, password, phone }: { email: string; password: string; phone?: string }) => void;
  onSetAuthStep: ({ authStep }: { authStep: AuthStep }) => void;
  reset: () => void;
}

export const useAuthStatus = (): UseAuthStepResponse => {
  const { userAuthState, userAuthDispatch } = useUserAuthContext();

  const onLoginIntentSuccess = ({ email, password, phone }: { email: string; password: string; phone?: string }) => {
    userAuthDispatch({
      type: UserAuthActionType.SET_USER_AUTH_STEP,
      payload: { authStep: `methodSelector` },
    });
    userAuthDispatch({
      type: UserAuthActionType.SET_USER_INTENT,
      payload: {
        userIntent: {
          email,
          password,
          phone,
        },
      },
    });
  };

  const onSetAuthStep = ({ authStep }: { authStep: AuthStep }) => {
    userAuthDispatch({
      type: UserAuthActionType.SET_USER_AUTH_STEP,
      payload: {
        authStep,
      },
    });
  };

  const reset = () => {
    userAuthDispatch({
      type: UserAuthActionType.RESET_USER_AUTH,
    });
  };

  return {
    authStep: userAuthState.authStep,
    userIntent: userAuthState.userIntent,
    twoFactorMethods: userAuthState.twoFactorMethods,
    onLoginIntentSuccess,
    onSetAuthStep,
    reset,
  };
};
